import { render } from "./AccountTypeShow.vue?vue&type=template&id=2d67a37f&scoped=true"
import script from "./AccountTypeShow.vue?vue&type=script&lang=js"
export * from "./AccountTypeShow.vue?vue&type=script&lang=js"

import "./AccountTypeShow.vue?vue&type=style&index=0&id=2d67a37f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d67a37f"]])

export default __exports__